import { type ReconnectEvent } from '../../../network-state-machine-events';

export async function closedAsync(): Promise<ReconnectEvent> {
  return {
    type: 'reconnect',
  };
}
